import type { FC, ReactNode } from "react";

import { InnerTitleContainer } from "pro-features/components/AutocompleteKeywords/styles/AutocompleteKeywordStyles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

interface ISection {
    header?: string | FC | null;
    content: ReactNode;
}

export const Section: FC<ISection> = ({ header: Header, content }) => {
    return (
        <FlexColumn>
            {Header ? (
                typeof Header === "string" ? (
                    <InnerTitleContainer>{Header}</InnerTitleContainer>
                ) : (
                    <Header />
                )
            ) : null}
            {content}
        </FlexColumn>
    );
};
